module.exports = __webpack_public_path__ + "static/media/dsr_about2.a75eed6e.svg";